import { Icon } from "@chakra-ui/react";
import { SideNavBody } from "../../components/containers/sideNavLayout/SideNavBody";
import { SideNavBar } from "../../components/containers/sideNavLayout/SideNavBar";
import { SideNavLayout } from "../../components/containers/sideNavLayout/SideNavLayout";
import { SideNavGroup } from "../../components/containers/sideNavLayout/SideNavGroup";
import { SideNavItem } from "../../components/containers/sideNavLayout/SideNavItem";
import { Outlet } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { BiSearchAlt } from "react-icons/bi";
import { IoMdAdd } from "react-icons/io";
import { PiSquaresFour } from "react-icons/pi";
import { useState } from "react";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../lib/cache";
import { IoPieChartOutline } from "react-icons/io5";
import { humanInTheLoopAccess } from "../../utils/accessControls";

export const PublisherHomePage: React.FC = () => {
  const currentUser = useReactiveVar(userDetailsVar);
  const [pageTitle, setPageTitle] = useState("Publisher");

  return (
    <SideNavLayout pageTitle={pageTitle}>
      <SideNavBar>
        <SideNavGroup
          title={"Segment Builder"}
          icon={<Icon as={IoPieChartOutline} width={6} height={6} />}
        >
          <SideNavItem
            title={"Segments"}
            url={"segments"}
            isSubItem={true}
            icon={<Icon as={CiViewList} width={6} height={6} />}
            setPageTitle={setPageTitle}
          />
          <SideNavItem
            title={"New Segment"}
            url={"segments/new"}
            isSubItem={true}
            icon={<Icon as={IoMdAdd} width={6} height={6} />}
            setPageTitle={setPageTitle}
          />
        </SideNavGroup>

        {currentUser?.isStaff && (
          <SideNavGroup
            title={"Campaigns"}
            icon={<Icon as={PiSquaresFour} width={6} height={6} />}
          >
            <SideNavItem
              title={"All Campaigns"}
              url={"campaigns"}
              isSubItem={true}
              icon={<Icon as={CiViewList} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
            <SideNavItem
              title={"New Campaign"}
              url={"campaigns/new"}
              isSubItem={true}
              icon={<Icon as={IoMdAdd} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
          </SideNavGroup>
        )}

        {currentUser &&
          (currentUser?.isStaff || humanInTheLoopAccess.includes(currentUser.agency.partner)) && (
            <SideNavItem
              title={"Human-AI"}
              subtitle={"URL Validator"}
              url={"human-in-the-loop/url-list"}
              icon={<Icon as={BiSearchAlt} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
          )}
      </SideNavBar>

      <SideNavBody pageTitle={pageTitle}>
        <Outlet />
      </SideNavBody>
    </SideNavLayout>
  );
};
